import type { Comic } from "@/types/comic";

export const comics: Comic[] = [
  {
    id: "top-manager-secret",
    title: "顶级经纪人的秘密",
    author: "白恩熙",
    categories: ["爱情", "都市"],
    status: "连载中",
    summary:
      "曾经跌落谷底的顶级经纪人韩世妍，意外接手了一位身份成谜的新人演员。对方冷漠又疏离，却总在关键时刻为她挡下所有麻烦。当过去的阴谋重新浮出水面，两人决定联手，把整个娱乐圈搅个天翻地覆。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20confident%20female%20talent%20manager%20in%20a%20stylish%20beige%20suit%20standing%20beside%20a%20handsome%20cold%20male%20actor%2C%20soft%20warm%20orange%20studio%20background%2C%20clean%20minimal%20composition%2C%20gentle%20gradient%20lighting%2C%20high%20detail%20digital%20painting%2C%20rim%20light%20on%20hair&width=600&height=800&seq=manhwa-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20manhwa%20webtoon%20key%20visual%20of%20a%20stylish%20female%20manager%20and%20a%20cold%20handsome%20male%20actor%20under%20dramatic%20warm%20amber%20stage%20lights%2C%20film%20set%20atmosphere%2C%20soft%20bokeh%2C%20warm%20orange%20and%20cream%20tones%2C%20digital%20painting%20illustration%2C%20cinematic%20depth&width=1600&height=900&seq=manhwa-banner-01&orientation=landscape",
    chapterCount: 86,
    latestChapter: "第 86 话 真正的对手",
    updatedAt: "2026-10-15",
    views: 1820000,
    rating: 9.4,
    tags: ["娱乐圈", "强强联合", "甜宠"],
  },
  {
    id: "sword-magic-dawn",
    title: "剑与魔法的黎明",
    author: "姜泰俊",
    categories: ["奇幻", "动作"],
    status: "连载中",
    summary:
      "魔法纪元崩塌百年后，被封印的古老剑士在少年凯尔的体内苏醒。为了寻找失落的黎明之剑，凯尔踏上穿越废墟大陆的旅途，与帝国骑士团和暗影教团展开一场决定世界命运的较量。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20enchanted%20blade%2C%20ruined%20ancient%20temple%20behind%20him%2C%20warm%20golden%20magic%20particles%20floating%2C%20rich%20orange%20and%20deep%20brown%20palette%2C%20dramatic%20lighting%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20battlefield%20key%20visual%20with%20a%20swordsman%20raising%20a%20glowing%20blade%20against%20a%20ruined%20ancient%20temple%2C%20golden%20magic%20energy%20swirling%2C%20warm%20amber%20and%20ember%20tones%2C%20wide%20cinematic%20composition%2C%20webtoon%20digital%20illustration&width=1600&height=900&seq=manhwa-banner-02&orientation=landscape",
    chapterCount: 120,
    latestChapter: "第 120 话 黎明决意",
    updatedAt: "2026-10-14",
    views: 1540000,
    rating: 9.2,
    tags: ["异世界", "热血", "冒险"],
  },
  {
    id: "seoul-street-king",
    title: "首尔街头霸王",
    author: "朴志勋",
    categories: ["动作", "都市"],
    status: "完结",
    summary:
      "从地下拳场走出来的少年姜道贤，为了守护唯一的妹妹，一路打上首尔最顶尖的格斗舞台。拳头、兄弟与背叛交织，他要面对的不只是对手，还有这座城市背后的黑暗势力。",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20action%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20determined%20young%20boxer%20wrapping%20his%20hands%20in%20tape%2C%20neon%20lit%20night%20city%20alley%20behind%2C%20warm%20orange%20neon%20glow%20mixed%20with%20dark%20shadows%2C%20powerful%20low%20angle%20composition%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Urban%20night%20battle%20key%20visual%20of%20a%20young%20fighter%20facing%20off%20in%20a%20crowded%20underground%20arena%2C%20warm%20orange%20neon%20signage%20reflecting%20on%20wet%20streets%2C%20cinematic%20wide%20shot%2C%20webtoon%20digital%20illustration%2C%20dramatic%20contrast&width=1600&height=900&seq=manhwa-banner-03&orientation=landscape",
    chapterCount: 210,
    latestChapter: "第 210 话 终章 · 归位",
    updatedAt: "2026-09-28",
    views: 2310000,
    rating: 9.5,
    tags: ["格斗", "兄弟情", "完本"],
  },
  {
    id: "deskmate-genius",
    title: "我的同桌是学神",
    author: "李秀妍",
    categories: ["校园", "爱情"],
    status: "连载中",
    summary:
      "转学生尹夏琳被迫和全校第一的冰山学神成为同桌。她以为对方只是难相处的优等生，直到发现他每天放学后都会偷偷出现在她打工的漫画店门口。青春的心动，从一张共享的课桌开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20two%20high%20school%20students%20sitting%20at%20a%20desk%20by%20a%20sunny%20classroom%20window%2C%20soft%20peach%20and%20cream%20tones%2C%20cherry%20blossom%20petals%20drifting%2C%20gentle%20shy%20expressions%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-04&orientation=portrait",
    chapterCount: 64,
    latestChapter: "第 64 话 学园祭的心意",
    updatedAt: "2026-10-15",
    views: 980000,
    rating: 9.1,
    tags: ["校园恋爱", "双向暗恋", "治愈"],
  },
  {
    id: "abyss-echo",
    title: "深渊回响",
    author: "郑在浩",
    categories: ["悬疑", "奇幻"],
    status: "连载中",
    summary:
      "连续七起失踪案的现场，都留下了同一段无法解释的低语。刑警徐振浩在调查中逐渐发现，那些声音来自城市地底的一座古老深渊。而他自己，似乎早就与深渊有着难以割舍的联系。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20mystery%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20detective%20holding%20a%20flashlight%20at%20the%20entrance%20of%20a%20mysterious%20underground%20tunnel%2C%20eerie%20warm%20amber%20light%20beams%2C%20heavy%20shadows%2C%20tense%20atmosphere%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Atmospheric%20horror%20mystery%20key%20visual%20of%20a%20foggy%20city%20street%20at%20dusk%20with%20a%20lone%20detective%20silhouette%20and%20glowing%20amber%20street%20lamps%2C%20eerie%20warm%20orange%20mist%2C%20cinematic%20wide%20composition%2C%20webtoon%20digital%20illustration&width=1600&height=900&seq=manhwa-banner-05&orientation=landscape",
    chapterCount: 78,
    latestChapter: "第 78 话 深渊之名",
    updatedAt: "2026-10-13",
    views: 1120000,
    rating: 9.3,
    tags: ["犯罪", "反转", "暗黑"],
  },
  {
    id: "chaebol-contract-bride",
    title: "财阀家的契约新娘",
    author: "金敏珠",
    categories: ["爱情", "都市"],
    status: "完结",
    summary:
      "为了偿还家里的债务，平凡女孩车秀雅签下了一纸契约婚姻。对象是集团最年轻却最冷漠的继承人。说好只是一场交易，可当契约期限临近，先动心的人却成了他。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20an%20elegant%20young%20woman%20in%20a%20cream%20wedding%20dress%20beside%20a%20suited%20cold%20handsome%20chaebol%20heir%2C%20luxurious%20marble%20hall%2C%20warm%20golden%20chandelier%20light%2C%20soft%20peach%20tones%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-06&orientation=portrait",
    chapterCount: 156,
    latestChapter: "第 156 话 终章 · 契约之外",
    updatedAt: "2026-09-20",
    views: 2050000,
    rating: 9.0,
    tags: ["契约婚姻", "先婚后爱", "完本"],
  },
  {
    id: "otherworld-food-hunter",
    title: "异界美食猎人",
    author: "崔宇彬",
    categories: ["奇幻"],
    status: "连载中",
    summary:
      "厨师林周元在一次意外中穿越到魔物横行的异世界。没有战斗天赋的他，却用一手厨艺征服了龙族公主、精灵猎人和帝国皇帝。毕竟要活下去，先得让最强的存在吃饱。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20fantasy%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20cheerful%20young%20chef%20cooking%20in%20a%20rustic%20wooden%20tavern%20while%20a%20small%20cute%20dragon%20watches%2C%20warm%20lantern%20glow%2C%20amber%20and%20cream%20tones%2C%20hearty%20inviting%20atmosphere%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-07&orientation=portrait",
    chapterCount: 92,
    latestChapter: "第 92 话 龙族的晚宴",
    updatedAt: "2026-10-12",
    views: 870000,
    rating: 8.9,
    tags: ["美食", "轻松", "异世界"],
  },
  {
    id: "reborn-actor",
    title: "重生之影帝归来",
    author: "韩政宇",
    categories: ["都市", "爱情"],
    status: "连载中",
    summary:
      "被最信任的人背叛而坠落的影帝裴俊浩，醒来时回到了十年前。这一次，他带着全部的记忆与演技，重新站上舞台，要让所有背叛者付出代价，也弥补那段错过的爱情。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20confident%20young%20actor%20in%20a%20sharp%20black%20suit%20standing%20before%20a%20glowing%20stage%2C%20warm%20spotlight%20beam%2C%20cinematic%20orange%20and%20charcoal%20palette%2C%20intense%20gaze%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-08&orientation=portrait",
    chapterCount: 134,
    latestChapter: "第 134 话 影帝的表演",
    updatedAt: "2026-10-11",
    views: 1330000,
    rating: 9.1,
    tags: ["重生", "复仇", "娱乐圈"],
  },
  {
    id: "doomsday-mecha",
    title: "末日机甲纪元",
    author: "吴承贤",
    categories: ["科幻", "动作"],
    status: "连载中",
    summary:
      "地表文明毁于一场虫潮，人类退守最后三座穹顶城。菜鸟驾驶员郑夏俊被选中最老旧的机甲，却意外唤醒了沉睡在机体深处的初代智能。要守住人类最后的火种，他必须先学会与这台「怪物」共存。",
    cover:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20young%20mecha%20pilot%20standing%20before%20a%20giant%20battle%20robot%20in%20a%20hangar%2C%20warm%20amber%20warning%20lights%2C%20steel%20and%20chrome%20details%2C%20epic%20scale%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20mecha%20key%20visual%20of%20giant%20robots%20facing%20a%20swarm%20of%20alien%20creatures%20under%20a%20burning%20orange%20sunset%20sky%2C%20ruined%20city%20skyline%2C%20cinematic%20wide%20composition%2C%20webtoon%20digital%20illustration&width=1600&height=900&seq=manhwa-banner-09&orientation=landscape",
    chapterCount: 101,
    latestChapter: "第 101 话 最后的火种",
    updatedAt: "2026-10-10",
    views: 1190000,
    rating: 9.0,
    tags: ["机甲", "末世", "热血"],
  },
  {
    id: "campus-youth-chronicle",
    title: "校园青春纪事",
    author: "尹智恩",
    categories: ["校园"],
    status: "完结",
    summary:
      "高三二班的五个少年少女，各自怀揣着不被理解的梦想。在升学压力与友情的拉扯中，他们用一整个夏天，写下了属于自己的青春答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20slice%20of%20life%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20five%20high%20school%20students%20laughing%20on%20a%20school%20rooftop%20at%20golden%20hour%2C%20warm%20sunset%20orange%20sky%2C%20gentle%20happy%20expressions%2C%20soft%20painterly%20style%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-10&orientation=portrait",
    chapterCount: 88,
    latestChapter: "第 88 话 终章 · 我们的夏天",
    updatedAt: "2026-08-30",
    views: 760000,
    rating: 8.8,
    tags: ["青春", "群像", "完本"],
  },
  {
    id: "blossom-girl-heart",
    title: "花漾少女心",
    author: "徐恩雅",
    categories: ["爱情", "校园"],
    status: "连载中",
    summary:
      "园艺社社长吴彩恩的心愿，是在毕业前让校园里那片荒废的花园重新盛开。而唯一愿意帮她的，是那个总把校服穿得乱糟糟、却意外温柔的问题学生。花开花落之间，喜欢悄悄生长。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20sweet%20romance%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20girl%20in%20a%20sunny%20school%20garden%20full%20of%20blooming%20flowers%20with%20a%20gentle%20boy%20beside%20her%2C%20warm%20peach%20and%20pink%20petals%2C%20dreamy%20soft%20light%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-11&orientation=portrait",
    chapterCount: 52,
    latestChapter: "第 52 话 花开的心意",
    updatedAt: "2026-10-14",
    views: 690000,
    rating: 8.9,
    tags: ["治愈", "甜宠", "校园恋爱"],
  },
  {
    id: "midnight-detective",
    title: "暗夜侦探社",
    author: "车民赫",
    categories: ["悬疑", "动作"],
    status: "连载中",
    summary:
      "只在午夜营业的侦探社，专门接手警方不愿触碰的案子。社长姜萨拉和她的搭档，在一桩桩离奇委托背后，逐渐逼近十年前那场灭门案的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20detective%20Korean%20manhwa%20webtoon%20cover%20illustration%20of%20a%20smartly%20dressed%20female%20detective%20in%20a%20dim%20office%20surrounded%20by%20case%20files%2C%20single%20warm%20desk%20lamp%20glow%2C%20amber%20and%20deep%20brown%20tones%2C%20mysterious%20atmosphere%2C%20detailed%20digital%20painting&width=600&height=800&seq=manhwa-cover-12&orientation=portrait",
    chapterCount: 73,
    latestChapter: "第 73 话 灭门案的回声",
    updatedAt: "2026-10-13",
    views: 940000,
    rating: 9.2,
    tags: ["推理", "单元剧", "悬疑"],
  },
];